class EditForm extends HTMLElement{
    constructor(){
        super();
        this.form = this.querySelector('form');
        this.birth = this.querySelector('#MyAccount-dob');
        this.gender = this.querySelector('#MyAccount-gender');
        this.gender.addEventListener("change", this.onChange.bind(this));
        this.birth.addEventListener("change", this.onChange.bind(this));
    }

    connectedCallback(){
        this.setBirth(this.birth.value);
        this.setGender(this.gender.value);
        this.setTags();
    }

    setBirth(birth){
        this.birth_value = birth;
    }

    setGender(gender){
        const _gender = gender.toLowerCase();
        if(_gender != "gender" ){
            this.gender_value = gender;
        }
        else{
            this.gender_value = ""
        }
    }

    setTags(){
        if(this.birth_value != ""){
            this.form.querySelector('#tags_value').value = "gender:" + this.gender_value + "," + "birth:" + this.birth_value;
        }
        else{
            this.form.querySelector('#tags_value').value = "gender:" + this.gender_value;
        }
    }

    //takes form as argument to use it in onload function 
    onChange(e){
        if(e.target.isSameNode(this.gender)){
            this.setGender(e.target.value);
        }
        if(e.target.isSameNode(this.birth)){
            this.setBirth(e.target.value);
        }
        this.setTags();
    }

 

}

customElements.define("edit-form", EditForm);

class EditFormNewsletter extends EditForm {
    constructor() {
        super();
        this.phone = this.querySelector('#phone-number');
        this.phonePrefix = this.querySelector('#phone_prefix');
        this.countryCodeMap = this.createCountryCodeMap();
        this.phone.addEventListener("keyup", this.onChange.bind(this));
        this.phonePrefix.addEventListener("change", this.onChange.bind(this));
    }

    connectedCallback() {
        super.connectedCallback();
        this.setPhone(this.phone.value, this.phonePrefix.value);
        this.setTags();
    }

    createCountryCodeMap() {
        const countryCodeMap = {};
        const options = this.phonePrefix.querySelectorAll('option');

        options.forEach(option => {
            const countryCode = option.value;
            const prefixText = option.textContent;

            const prefixMatch = prefixText.match(/\(\+(\d+)\)/);
            if (prefixMatch) {
                const prefix = `+${prefixMatch[1]}`;
                countryCodeMap[countryCode] = prefix;
            }
        });

        return countryCodeMap;
    }

    formatPhoneNumber(phone) {
        const countryCode = phone.slice(0, 2).toUpperCase();
        if (this.countryCodeMap[countryCode]) {
            const prefix = this.countryCodeMap[countryCode];
            return prefix + phone.slice(2);
        }
        return phone;
    }

    setPhone(phone, countryCode) {
        const prefix = this.countryCodeMap[countryCode];
        const formattedPhone = this.formatPhoneNumber(prefix + phone);
        this.phone_value = formattedPhone;
    }

    submitCustomerForm() {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            console.log("submitting form");
            const customerData = {
                first_name: this.form.querySelector('first_name').value,
                last_name: this.form.querySelector('last_name').value,
                phone: this.phone_value,
                email: this.form.querySelector('email').value,
                accepts_marketing: this.form.querySelector('#accepts_marketing').value,
                accepts_marketing_sms: true
            };
            fetch('/customers.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(customerData)
            }).then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok.');
            }).then(jsonResponse => {
                console.log(jsonResponse);
            }).catch(error => {
                console.log('There has been a problem with your fetch operation:', error);
            });
        });
    }

    setTags() {
        let tags = `gender:${this.gender_value}`;
        if (this.birth_value !== "") {
            tags += `,birth:${this.birth_value}`;
        }
        if (this.phone.value !== "" && this.isValidPhoneNumber(this.phone.value)) {
            tags += `,phone:${this.phone_value}`;
        }
        this.form.querySelector('#tags_value').value = tags;
    }

    isValidPhoneNumber(phone) {
        const phoneRegex = /^\d{10}$/;
        return phoneRegex.test(phone);
    }

    onChange(e) {
        if (e.target.isSameNode(this.gender)) {
            this.setGender(e.target.value);
        }
        if (e.target.isSameNode(this.birth)) {
            this.setBirth(e.target.value);
        }
        if (e.target.isSameNode(this.phone) || e.target.isSameNode(this.phonePrefix)) {
            this.setPhone(this.phone.value, this.phonePrefix.value);
        }
        this.setTags();
    }
}

customElements.define("edit-form-newsletter", EditFormNewsletter);
